/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum StationaryUnitType {
    STATIONARY_UNIT = 'stationaryUnit',
    VERIFICATION_UNIT = 'verificationUnit'
}


export function instanceOfStationaryUnitType(value: any): boolean {
    for (const key in StationaryUnitType) {
        if (Object.prototype.hasOwnProperty.call(StationaryUnitType, key)) {
            if (StationaryUnitType[key as keyof typeof StationaryUnitType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StationaryUnitTypeFromJSON(json: any): StationaryUnitType {
    return StationaryUnitTypeFromJSONTyped(json, false);
}

export function StationaryUnitTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): StationaryUnitType {
    return json as StationaryUnitType;
}

export function StationaryUnitTypeToJSON(value?: StationaryUnitType | null): any {
    return value as any;
}

export function StationaryUnitTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): StationaryUnitType {
    return value as StationaryUnitType;
}

